import React from 'react'
import { Link } from "react-router-dom"
import { CiEdit } from "react-icons/ci";
import { MdOutlinePreview } from "react-icons/md";
import { useState } from 'react';
import {API} from '../../../Services/axios'
import {URLS} from '../../../Services/Urls';
import { FaPlus } from "react-icons/fa";
import { ImPlus } from "react-icons/im";
import { toast } from 'react-toastify';
import useSWR from 'swr';



const ProjectContent = () => {


  const [project, setProject] = useState({})

  // Always use configured endpoints (prevents SSL/cert mismatch on other domains).
  const key = URLS.PROJECT.createProject
  
  const fetcher = (url) =>
    API.get(url)
      .then((res) => res.data)
      .catch((err) => {
        console.error("Error in fetcher:", err);
        throw err;
      });

  const { data: projects, error, isLoading: loadingProjects} = useSWR(key, fetcher, {
    // Avoid retry spam on network/SSL certificate errors.
    shouldRetryOnError: false,
    revalidateOnFocus: false,
  })
  const projectsArray = projects?.results;

  if (error) {
    return (
      <div className='mt-5'>
        Error loading projects
        <div className="text-muted small mt-2">
          Si tu vois <code>ERR_CERT_AUTHORITY_INVALID</code>, le navigateur bloque l’API (certificat SSL).
          Vérifie le domaine dans <code>src/Services/Urls.js</code> (BASE_URL).
        </div>
      </div>
    );
  }
  if (loadingProjects) {
    return (
      <div className="d-flex justify-content-center align-items-center py-5 mt-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Chargement des projets...</span>
        </div>
      </div>
    );
  }
  if (!projects) {
    return <div className='mt-5'>No projects</div>
  }

  console.log("Fetching projects from:", URLS.BASE_URL + key);

  const handleFetchProjects = () => {
    // API.get(URLS.PROJECT.createProject)
    //   .then((resp) => {
    //     setProject(resp.data)
    //     console.log("Create Project:", resp.data)
    //   })
    //   .catch((error) => {
    //     toast.error(error?.response?.data?.detail)
    //   })
    console.log("ProjectsArray:", projectsArray)
  }

  return (
  <>
    
  {/***********************************
  Content body start************************************/}
    <div className="content-body">
      <div className="container-fluid">
        <div className="row">
          {projectsArray.map(p => (
            <div className="col-md-3 col-sm-4 col-12">
              <div className=''>
                <div className="card p-0 project-card">
                  <img src="https://blog.neowood.fr/hubfs/Imported_Blog_Media/bois-bardage-2-2.jpg" alt="" />
                  <div className="project-card-slide p-2">
                    <p className="projet px-4">[Projet]</p>
                    <p className="projet-name px-4">{p.name}</p>
                    <div className="project-utils">
                      <div className="d-flex">
                        <Link to={`/projet/${p.id}`} className='edit-link me-2'> 
                          <span className="d-flex">
                            <span className='m-auto'><MdOutlinePreview /></span>
                            <span className='ms-1'>Apercu</span>
                          </span>
                        </Link>
                        
                        <Link to={`/projet/${p.id}`} className='edit-link'>
                          <span className="d-flex">
                            <span className='m-auto'><CiEdit /></span>
                            <span className='ms-1'>Modifier</span>
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
          
          {/* <div className="col-md-3 col-sm-4 col-12">
            <div className=''>
              <div className="card p-0 project-card">
                <img src="https://blog.neowood.fr/hubfs/Imported_Blog_Media/bois-bardage-2-2.jpg" alt="" />
                <div className="project-card-slide p-2">
                  <p className="projet px-4">[Projet]</p>
                  <p className="projet-name px-4">Bardage et terasse</p>
                  <div className="project-utils">
                    <div className="d-flex">
                      <Link to={"projects/23/edit"} className='edit-link me-2'> 
                        <span className="d-flex">
                          <span className='m-auto'><MdOutlinePreview />
                          </span>
                          <span className='ms-1'>Apercu</span>
                        </span>
                      </Link>
                      <Link to={"projects/23/edit"} className='edit-link'> 
                        <span className="d-flex">
                          <span className='m-auto'><CiEdit /></span>
                          <span className='ms-1'>Modifier</span>
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-4 col-12">
            <div className=''>
              <div className="card p-0 project-card">
                <img src="https://blog.neowood.fr/hubfs/Imported_Blog_Media/bois-bardage-2-2.jpg" alt="" />
                <div className="project-card-slide p-2">
                  <p className="projet px-4">[Projet]</p>
                  <p className="projet-name px-4">Bardage et terasse</p>
                  <div className="project-utils">
                    <div className="d-flex">
                      <Link to={"projects/23/edit"} className='edit-link me-2'> 
                        <span className="d-flex">
                          <span className='m-auto'><MdOutlinePreview />
                          </span>
                          <span className='ms-1'>Apercu</span>
                        </span>
                      </Link>
                      <Link to={"projects/23/edit"} className='edit-link'> 
                        <span className="d-flex">
                          <span className='m-auto'><CiEdit /></span>
                          <span className='ms-1'>Modifier</span>
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          <div className="col-md-3 col-sm-4 col-12">
            <div className='card p-0 project-card rounded-2 d-flex align-items-center justify-content-center'>
              <ImPlus onClick={()=> handleFetchProjects()}/>
            </div>
          </div>
        </div>
      </div>
    </div>
      
      
    </>
  )
}

export default ProjectContent

